module.exports = __webpack_public_path__ + "static/moocfi-logo-bw-d716fad7edf338591c659310e1179fbf.png";